import {GET_CUSTOMER_DATA_START, GET_CUSTOMER_DATA_SUCCESS, GET_CUSTOMER_DATA_FAILURE, RESET_REDUX} from "../../actions/actionTypes";
import { Role } from "../../model/Role";

const initialState = {
  customerNumber: '',
  email: '',
  roles: [],
  country: {
    name: '',
    isocode: '',
  },
  firstName: '',
  lastName: '',
  defaultAddress: '',
  loginDisabled: false,
  isPortalMaster: false,
  isDistributor: false,
  isSalesRep: false,
  isDealer: false,
  isDiSalesRep: false,
  isDiDealer: false,
  isOrderRestricted: false,
  loading: false,
  errors: null,
  dataCollected: false,
  orderScenarios: [],
  siteUid: null,
};

const customerDataReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case GET_CUSTOMER_DATA_START : {
      return {
        ...state,
        loading: true,
      }
    }
    case GET_CUSTOMER_DATA_SUCCESS : {
      return {
        ...state,
        customerNumber: action.payload.customerNumber,
        email: action.payload.email,
        roles: action.payload.roles,
        country: action.payload.country,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        defaultAddress: action.payload.defaultAddress,
        loginDisabled: action.payload.loginDisabled,
        isPortalMaster: action.payload.roles.includes(Role.PORTAL_MASTER),
        isDistributor: action.payload.roles.includes(Role.DISTRIBUTOR),
        isSalesRep: action.payload.roles.includes(Role.SALES_REP),
        isDealer: action.payload.roles.includes(Role.DEALER),
        isHeadquarters: action.payload.roles.includes(Role.HEADQUARTERS),
        isDiSalesRep: action.payload.roles.includes(Role.DI_SALES_REP),
        isDiDealer: action.payload.roles.includes(Role.DI_DEALER),
        isOrderRestricted: action.payload.roles.includes(Role.ORDER_RESTRICTED),
        loading: false,
        errors: null,
        dataCollected: true,
        orderScenarios: action.payload.orderScenarios,
        siteUid: action.payload.siteUid,
      }
    }
    case GET_CUSTOMER_DATA_FAILURE: {
      return {
        ...state,
        errors: action.payload.errors,
        loading: false
      }
    }
    case RESET_REDUX: {
      return {...initialState}
    }
    default: {
      return state;
    }
  }
};

export default customerDataReducer;
